import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormInput } from 'elements/Inputs/FormInput/';
import { StyledLabel } from 'elements/Label/Label';
import { selectFoundThresholdForForm } from './FoundThresholdSection.data';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    }
}));

const FoundThresholdSection = (props) => {
    const { selectedTag, changeHandler, formData, formName, isFormReadOnly, userRole } = props;
    const classes = useStyles();
    return (
        <Grid container spacing={1} className={classes.root}>
            {
                selectFoundThresholdForForm(selectedTag, formName, formData).rows.map(row => (
                    <Grid item container xs={12} key={row.key} style={{ paddingBottom: '0', paddingTop: '0' }}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {
                                    field.isLabel
                                        ? (
                                            <StyledLabel
                                                id={field.key}
                                                fontWeight={field.fontWeight}
                                                textAlign={field.textAlign}
                                                labelWidth={field.labelWidth}
                                                padding={field.padding}
                                                fontSize={field.fontSize}
                                                marginTop={field.marginTop}
                                            >
                                                {field.label}
                                            </StyledLabel>
                                        )
                                        : (
                                            <FormInput
                                                id={field.key}
                                                name={field.key}
                                                label={field.label}
                                                value={field.value}
                                                isRequired={field.isRequired}
                                                isCalculated={field.isCalculated}
                                                handleChange={changeHandler}
                                                readOnly={field.readOnly || isFormReadOnly}
                                                type={field.type}
                                                direction={field.direction}
                                                width={field.width}
                                                labelWidth={field.labelWidth}
                                                marginRight={field.marginRight}
                                                marginLeft={field.marginLeft}
                                                padding={field.padding}
                                                maxLength={field.maxLength}
                                                borderTop={field.borderTop}
                                                borderRight={field.borderRight}
                                                textAlign={field.textAlign}
                                                userRole={userRole}
                                                marginTop={field.marginTop}
                                                borderLeft={field.borderLeft}
                                                borderBottom={field.borderBottom}
                                            />
                                        )
                                }
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </Grid>
    );
};

const mapStateToProps = ({ Forms, Home }) => ({
    selectedTag: Forms.selectedTag,
    userRole: Home.userRole
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FoundThresholdSection);

FoundThresholdSection.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
    userRole: PropTypes.string,
};
